<template>
<div style="height: 100%">
  <div style="height: 10px"></div>
  <div style="height: 30px;margin: 0 30px">
    <img style="vertical-align: bottom" title="心率" src="/static/health/icon_heart.png">
    <span style="color: #cccccc;font-size: 18px">心率图</span>
    <span style="color: #999999">次/分</span>
  </div>
  <div style="height: calc(100% - 40px)" id="heartBeat" ref="line_wrap1"></div>
</div>
</template>

<script>
export default {
  name: 'heartBeat',
  data () {
    return {
      yData: [],
      xData: [],
      isShow: false
    }
  },
  created () {
  },
  mounted () {
    this.initCharts()
    this.isShow = true
  },
  methods: {
    getStartData (arr) {
      for (let i = 0; i < arr.length; i++) {
        this.xData.push(arr[i].time)
        this.yData.push(arr[i].heartbeat)
      }
      if (this.isShow) {
        this.initCharts()
      }
    },
    initCharts () {
      let chart = this.$echarts.init(this.$refs.line_wrap1)
      chart.setOption({
        tooltip: {
          trigger: 'axis'
        },
        xAxis: [{
          data: this.xData,
          axisLine: {
            lineStyle: {
              color: '#fff',
              width: 1
            }
          }
        }],
        yAxis: [{
          splitLine: {show: false},
          axisLine: {
            lineStyle: {
              color: '#fff',
              width: 1 // 这里是为了突出显示加上的
            }
          }
        }],
        grid: [{
          right: '5%',
          top: '10%',
          bottom: '15%'
        }],
        series: [{
          type: 'line',
          showSymbol: false,
          data: this.yData
        }],
        color: ['#00d4ff']
      })
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/datamanagement/healthComponents/heartBeat.vue